// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_02712f2b3b--carousel--FCofi"};